import BigNumber from 'bignumber.js'

export function calProbFromHashRange(hash: string, from: number, to: number) {
  // Return probability in [0, 1)
  const hexSubstring = hash.substring(from, to)
  const hashBase = new BigNumber(2).pow((to - from) * 4)

  let decVal: BigNumber
  try {
    decVal = new BigNumber(parseInt(hexSubstring, 16))
  } catch (err) {
    console.error('Error parsing integer:', err)
    return null
  }

  return decVal.div(hashBase)
}

export function calProbFromHash(hash: string, hashHexLength: number) {
  // Return prob in [0, 1)
  const hexSubstring = hash.slice(0, hashHexLength)
  const hashBase = new BigNumber(2).pow(hashHexLength * 4)
  const decVal = new BigNumber(parseInt(hexSubstring, 16))
  const prob = decVal.div(hashBase)
  return prob
}

export const HASH_HEX_LENGTH = 8
